import { useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';

const useGetMediaInStore = (storeId: string) => {
  const dispatch = useAppDispatch();
  const mediaInStore = storeSelectors.getMediaInStore();

  const mutate = (path: string, keySearch?: string) => {
    dispatch(storeActions.getMediaInStore.fetch({ path, keySearch, storeId }));
  };

  useEffect(() => {
    if (!storeId) return;
    mutate(' ', undefined);
  }, [storeId]);

  return {
    mediaInStore,
    mutate,
  };
};

export default useGetMediaInStore;
